import styled from 'styled-components'
import { Flex } from '../../../../../styles/styledGlobal'

export const Main = styled.div`
display: flex;
flex-direction: column;
max-width: 34.375rem;
h4{
}

span:last-child{
    font-family: 'Poppins','sans-serif';
    font-size: 14px;
}
`

export const Description = styled.span`
margin-left: 0rem;
font-size: 14px;
`

export const WelcomeContainer = styled(Flex)`
align-items: center;
margin-bottom: 1rem;
`

export const VideoBox = styled.video`
min-width:110px;
max-width:110px;
height: 110px;
margin-right: 1rem;
margin-top: .25rem;
background-repeat: no-repeat;
background-size: contain;
background-position: center;
border-radius: .5rem;
border: 1px solid var(--c5);
`
